<template lang="pug">
  .footer
    div
      router-link.official(tag="div" to="/")
        img(:src="alphaLogo")
      p.location {{ location }}
      p.locationEn {{ locationEn }}
      p +86-(0755) 8238 5582
      p services@alphaif.com
      p.link(@click="gotoLink2('#')") 粤ICP备19082412号
    div
      h4 产品
      p.link(v-for="item in product" @click="gotoLink(item)") {{ item }}
    div
      h4 解决方案
      p.link(v-for="item in totalSolution" @click="gotoLink(item)") {{ item }}
    div
      h4 公司事件
      div.corporateEvent(v-for="item in corporateEvents")
        div
          img(:src="item.img")
        div
          span {{ item.title }}
          span {{ item.date }}
    div
      h4 产品标签
      div
        .aas(v-for="item in aas") {{ item }}
</template>

<script>
  import alphaLogo from '@/assets/images/alphacloudlogo.png';
  import linkHiNan from '@/assets/images/阿尔法与“链上海南”战略合作.png';
  import highTech from '@/assets/images/高交会.jpg';
  import {isPhone} from "@/utils/utils";

  export default {
    name: "bottomFooter",
    data() {
      return {
        alpha: 'http://www.alphaif.com/',
        alphaLogo,
        location: '中国深圳南山区深圳湾科技生态园\n10栋B座514号',
        locationEn: '514, floor 5, building 10b,\nEcological Science Park,\nNanShan District, ShenZhen',
        product: ['IOT OPS', 'DATA OPS', 'AI OPS', 'RCMD OPS', 'MKT OPS'],
        totalSolution: ['FACE SAAS', 'MARKETING', 'PERSONALIZED RECOMMENDATIONS', 'DIGITAL EDUCTION', 'DIGITAL CITY'],
        corporateEvents: [
          {img: linkHiNan, title: 'DIGITAL CIVILIZATION CONFERENCE', date: 'DEC 04, 2019'},
          {img: highTech, title: 'HIGH-TECH EXCHANGE CONFERENCE', date: 'NOV 13, 2019'},
        ],
        aas: ['INTELLIGENT', 'IAAS', 'PAAS', 'BIG DATA', 'SAAS', 'LEAD', 'DAAS'],
      };
    },
    methods: {
      gotoOfficial() {
        const alphaOfficialLink = this.alpha;
        if (isPhone()) {
          this.$alert(`建议您通过PC端浏览器打开官网, \n网址：${alphaOfficialLink}`, "通知", {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            showCancelButton: true,
            center: true,
            callback(action) {
              if (action === 'confirm') {
                window.open(alphaOfficialLink, '_blank');
              }
            }
          })
        } else {
          window.open(alphaOfficialLink, '_blank');
        }
      },
      gotoLink2() {
        window.location.href = 'https://beian.miit.gov.cn';
      },
      gotoLink(link) {
        const linkRoute = {
          'IOT OPS': 'IotOps',
          'DATA OPS': 'BigDataOps',
          'AI OPS': 'AIOps',
          'RCMD OPS': 'RecommendationOps',
          'MKT OPS': 'MarketingOps',
  
          'FACE SAAS': 'FaceSaaS',
          'MARKETING': 'PrecisionMarketing',
          'PERSONALIZED RECOMMENDATIONS': 'Recommendation',
          'DIGITAL EDUCTION': 'DigitalEducation',
          'DIGITAL CITY': 'DigitalCity',
        }
        this.$router.push({name: linkRoute[link]});
        window.scroll(0, 0);
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import "../views/index.styl"
  .footer {
    display flex
    justify-content center
    align-items flex-start
    width 100%
    padding 100px 0 50px
    background-color #222222
    .official {
      cursor pointer
    }
    h4 {
      font-size 1.2rem
      margin-top 12px
      margin-bottom 16px
      color white
      FontSetting("Lora", Montserrat, "思源黑体 CN Normal")
    }
    
    p {
      line-height 24px
      FontSetting("Montserrat")
      font-size (12 / 14)rem
    }
    
    .location {
      font-size (14 / 14)rem
    }
    .locationEn {
      font-size (12 / 14)rem
      margin-top 0
      line-height 14px
    }
    
    p, span {
      color #808080
    }
    
    > div {
      display flex
      flex-direction column
      align-items flex-start
      justify-content flex-start
      margin 0 30px
      &:first-child {
        min-width 240px
        max-width 300px
      }
      &:nth-child(2) {
        min-width 80px
      }
      &:nth-child(3) {
        min-width 154px
      }
      > img {
        margin-top: 6px;
        margin-bottom: 10px;
      }
      
      > p {
        margin 6px 0
      }
      
      > div {
        display flex
        justify-content flex-start
        flex-wrap wrap
        width 155px
        
        > .aas {
          background-color #2f2f2f
          color #808080
          font-size (12 / 14)rem
          text-align center
          padding 12px
          margin 1px
        }
  
      }
    }
    
    .corporateEvent {
      display flex
      align-items center
      flex-wrap nowrap
      width 350px
      margin-bottom 20px
      
      > div:first-of-type {
        height 60px
        width 60px
        flex-shrink 0
        margin-right 20px
        
        > img {
          height 100%
          width 100%
          object-fit cover
        }
      }
      
      > div:nth-child(2) {
        display flex
        flex-direction column
        align-items flex-start
        
        > span {
          display inline-block
          font-size (12 / 14)rem
          FontSetting(Montserrat)
        }
        
        > span:first-of-type {
          color white
        }
        
        > span:nth-child {
          color #808080
        }
      }
    }
  }
  .link {
    cursor pointer
    &:hover {
      color white
    }
    &:first-of-type {
      margin-top 0
    }
  }
  @media (max-width ipadProScreenWidth) {
    .footer {
      > div {
        .corporateEvent {
          width auto
        }
        &:last-child {
          display none
        }
      }
    }
  }
  @media (max-width screenWidth) {
    .footer {
      padding 30px 0
      VStack(center)
      .locationEn {
        display none
      }
      > div:first-child {
        max-width 100vw
        > p {
          margin 0
        }
      }
      > div:not(:first-child) {
        display none
      }
    }
  }
</style>
